import { usePageTitle } from '../hooks/usePageTitle'
import { MagicLinkSignIn } from '../components/MagicLinkSignIn'
import { ExpiredLinkNotice, JoinCard, JoinPage } from '../components/golf'

/**
 * The application (route map §4 `/join`) — step I of the join flow.
 *
 * This is the one page in the launch that is fully functional: the card is the
 * real magic-link form. It still carries that form after /sign-in split off,
 * because one POST serves both doors (find_or_create_email_user) — an applicant
 * gets in by the same link a member does. What /sign-in took away is only the
 * job of greeting members with founding-seat copy.
 *
 * The notice still renders here too: /join?auth=invalid_link is in browser
 * histories and QA runbooks even though the backend now sends dead links to
 * /sign-in.
 */
export function JoinApplyScreen() {
  usePageTitle('Apply')

  return (
    <JoinPage stepNumeral="I" stepLabel="The Application">
      <ExpiredLinkNotice />

      <JoinCard>
        <MagicLinkSignIn />
      </JoinCard>
    </JoinPage>
  )
}
